import { render } from "./IconPrinter.vue?vue&type=template&id=14ae9ad6"
import script from "./IconPrinter.vue?vue&type=script&lang=ts"
export * from "./IconPrinter.vue?vue&type=script&lang=ts"
script.render = render

export default script